"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$transitions, _theme$transitions$ea, _theme$transitions2, _theme$transitions2$e;

  return {
    root: {
      alignItems: "center",
      bottom: 0,
      display: "flex",
      flex: "0 0 100%",
      justifyContent: "center",
      left: 0,
      opacity: 0,
      position: "absolute",
      right: 0,
      top: 0,
      transition: theme.transitions.create("opacity", {
        easing: (_theme$transitions = theme.transitions) === null || _theme$transitions === void 0 ? void 0 : (_theme$transitions$ea = _theme$transitions.easing) === null || _theme$transitions$ea === void 0 ? void 0 : _theme$transitions$ea.easeIn,
        duration: 1000
      }),
      zIndex: 1,
      "& picture": {
        height: "100%",
        width: "100%",
        "& img": {
          height: "100%",
          width: "100%"
        }
      }
    },
    show: {
      opacity: 1,
      zIndex: 2,
      "& .mco-animation-01__texts": {
        opacity: 1
      }
    },
    texts: {
      opacity: 0,
      position: "absolute",
      transition: theme.transitions.create("opacity", {
        easing: (_theme$transitions2 = theme.transitions) === null || _theme$transitions2 === void 0 ? void 0 : (_theme$transitions2$e = _theme$transitions2.easing) === null || _theme$transitions2$e === void 0 ? void 0 : _theme$transitions2$e.easeIn,
        duration: 1000
      }),
      zIndex: 2
    }
  };
});
var _default = styles;
exports.default = _default;